import { ClientSymbolListMode } from '@cbridge-modules/symbol-client-data-grid';
import { ISymbolClientControllerStore } from './controllerSymbolClient.interface';

export const symbolClientControllerInitialState: ISymbolClientControllerStore = {
  mode: ClientSymbolListMode.Basic,
};
